<template>
  <div v-loading="formLoading">
    <!-- 主数据信息 -->
    <div class="secondStep">
      <el-form
        style="width: 1196px"
        :model="extForm.subconChangeInfo"
        :rules="rules"
        ref="ruleForm"
        label-width="60px"
        class="demo-ruleForm"
      >
        <div class="title">
          <span></span>
          <div>主数据信息</div>
        </div>
        <div class="masterDataInformation">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                prop="subconName"
                label="分包商名称："
              >
                <el-input
                  style="width: 277px"
                  disabled
                  v-model="extForm.subconChangeInfo.subconName"
                  placeholder="请输入分包商名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- {{extForm.subconChangeInfo}} -->
              <el-form-item
                label-width="190px"
                prop="cooUnitName"
                label="合作单位："
              >
                <el-input
                  disabled
                  style="width: 277px"
                  v-model="extForm.subconChangeInfo.cooUnitName"
                  placeholder="请输入合作单位"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="统一社会信用代码："
                prop="unifiedCreditCode"
              >
                <el-input
                  disabled
                  style="width: 277px"
                  placeholder="请输入统一社会信用代码"
                  v-model="extForm.subconChangeInfo.unifiedCreditCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="企业性质："
                prop="comNatureName"
              >
                <!-- prop="comNatureName" -->
                <span slot="label">
                  <span class="span-box">
                    <span>企业性质：</span>
                    <el-tooltip
                      style="display: inline; z-index: 1000"
                      effect="dark"
                      content="企业的所有制形式"
                      placement="top"
                    >
                      <i class="el-icon-question" />
                    </el-tooltip>
                  </span>
                </span>
                <el-input
                  v-model="extForm.subconChangeInfo.comNatureName"
                  @click.native="centerDialogVisible = true"
                  placeholder="请选择企业性质"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="往来单位类别："
                prop="subconCategoryName"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.subconCategoryName"
                  @click.native="categoryDialogVisible = true"
                  placeholder="请选择往来单位类别"
                ></el-input>
                <!--                <el-select-->
                <!--                  @change="getCategoryCode"-->
                <!--                  v-model="extForm.subconChangeInfo.subconCategoryName"-->
                <!--                  placeholder="请选择"-->
                <!--                >-->
                <!--                  <el-option-->
                <!--                    v-for="item in listSubconCategory"-->
                <!--                    :key="item.categoryCode"-->
                <!--                    :label="item.name"-->
                <!--                    :value="item.categoryCode"-->
                <!--                  ></el-option>-->
                <!--                </el-select>-->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="往来单位性质："
                prop="subconNatureName"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.subconNatureName"
                  @click.native="natureDialogVisible = true"
                  placeholder="请选择往来单位性质"
                ></el-input>
                <!--<el-select
                  @change="getNatureCode"
                  v-model="extForm.subconChangeInfo.subconNatureName"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in listSubconNature"
                    :key="item.natureCode"
                    :label="item.name"
                    :value="item.natureCode"
                  ></el-option>
                </el-select>-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="分包商英文名称："
                prop="subconUsName"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.subconUsName"
                  placeholder="请输入分包商英文名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 分包商简称 -->
            <el-col :span="12">
              <el-form-item label-width="190px" label="分包商简称：" prop="">
                <el-input
                  v-model="extForm.subconChangeInfo.subconShortName"
                  placeholder="请输入分包商简称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人姓名："
                prop="legalPersonName"
              >
                <el-input
                  disabled
                  style="width: 277px"
                  v-model="extForm.subconChangeInfo.legalPersonName"
                  placeholder="请输入法人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人电话号码："
                prop="legalPersonPhone"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.legalPersonPhone"
                  placeholder="请输入法人电话号码"
                  maxlength="11"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人证件类型："
                prop="cardType"
              >
                <el-select
                  v-model="extForm.subconChangeInfo.cardType"
                  placeholder="请选择"
                  @change="$forceUpdate()"
                >
                  <el-option label="身份证" value="0"></el-option>
                  <el-option label="护照" value="1"></el-option>
                  <el-option label="其他" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人证件号码："
                prop="legalPersonIdCard"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.legalPersonIdCard"
                  placeholder="请输入法人证件号码"
                  maxlength="18"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人证件号码有效期："
                prop="legalPersonCardValidityStart"
              >
                <el-date-picker
                  v-model="
                    extForm.subconChangeInfo.legalPersonCardValidityStart
                  "
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
                <!--                <el-date-picker-->
                <!--                  v-model="-->
                <!--                    extForm.subconChangeInfo.legalPersonCardValidityStart1-->
                <!--                  "-->
                <!--                  @change="changePicker"-->
                <!--                  :clearable="false"-->
                <!--                  align="right"-->
                <!--                  type="daterange"-->
                <!--                  value-format="yyyy-MM-dd"-->
                <!--                  range-separator="至"-->
                <!--                  start-placeholder="开始日期"-->
                <!--                  end-placeholder="结束日期"-->
                <!--                  :picker-options="pickerOptions"-->
                <!--                >-->
                <!--                </el-date-picker>-->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人证件号码截止期："
                prop="legalPersonCardValidityEnd"
              >
                <el-date-picker
                  v-model="extForm.subconChangeInfo.legalPersonCardValidityEnd"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="190px"
                label="是否内部单位："
                prop="yesNo"
              >
                <el-radio-group v-model="extForm.subconChangeInfo.yesNo">
                  <el-radio label="是"></el-radio>
                  <el-radio label="否"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="所在地："
                prop="countrys"
              >
                <scma-area-selector
                  ref="myCascader"
                  :defaultArea="defaultArea"
                  @getAddressOf="getAddressOf"
                  :place="leftPlace"
                  :url="areaUrl"
                  :agentId="paramsData"
                  :headers="headers"
                ></scma-area-selector>
              </el-form-item>
              <!--<el-form-item
                label-width="190px"
                label="所在地："
                prop="countrys"
              >
                <el-cascader
                  v-model="extForm.subconChangeInfo.countrys"
                  :inputValue="extForm.subconChangeInfo.inputValue"
                  ref="myCascader"
                  :props="propsPlace"
                  @change="handleChange"
                  clearable
                ></el-cascader>
              </el-form-item>-->
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="190px" label="所属集团公司：">
                <el-input
                  v-model="extForm.subconChangeInfo.subsidiaryGroupName"
                  placeholder="请输入所属集团公司"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- uploadId -->
              <!-- {{JSON.parse(extForm.subconChangeInfo.legalPersonCardFront).uploadId }} -->
              <el-form-item
                label-width="200px"
                label="身份证扫描件正面："
                prop="legalPersonCardFront"
              >
                <frontPhotoOfIdCard
                  :uploadUrl="extForm.subconChangeInfo.legalPersonCardFront"
                  @uploadUrlZm="getUrlZm"
                ></frontPhotoOfIdCard>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="200px"
                label="身份证扫描件反面："
                prop="legalPersonCardBack"
              >
                <reversePhotoOfIdCard
                  :uploadUrl="extForm.subconChangeInfo.legalPersonCardBack"
                  @uploadUrlFm="getUrlFm"
                ></reversePhotoOfIdCard>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="width: 1196px !important"></el-row>
        </div>
      </el-form>
    </div>
    <!-- 注册账号信息 -->
    <div class="secondStep">
      <el-form
        :model="extForm.subconAuthAccountInfo"
        :rules="rules1"
        ref="accountInformation"
        label-width="60px"
        class="demo-ruleForm"
      >
        <div class="title">
          <span></span>
          <div>注册账户信息</div>
        </div>
        <div class="masterDataInformation">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册联系人："
                prop="authUserName"
              >
                <el-input
                  style="width: 277px"
                  v-model="extForm.subconAuthAccountInfo.authUserName"
                  placeholder="请输入注册联系人姓名"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册联系人手机号："
                prop="phone"
              >
                <div class="verificationCode">
                  <el-input
                    style="width: 277px"
                    disabled
                    placeholder="请输入注册联系人手机号"
                    v-model="extForm.subconAuthAccountInfo.phone"
                    maxlength="11"
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册联系人证件类型："
                prop="cardType"
              >
                <el-select
                  v-model="extForm.subconAuthAccountInfo.cardType"
                  placeholder="请选择"
                  @change="$forceUpdate()"
                >
                  <el-option label="身份证" value="0"></el-option>
                  <el-option label="护照" value="1"></el-option>
                  <el-option label="其他" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册联系人证件号码："
                prop="authPersonIdCard"
              >
                <el-input
                  v-model="extForm.subconAuthAccountInfo.authPersonIdCard"
                  placeholder="请输入注册联系人证件号码"
                  maxlength="18"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册邮箱："
                prop="registerEmail"
              >
                <el-input
                  v-model="extForm.subconAuthAccountInfo.registerEmail"
                  placeholder="请输入邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!--          <el-row>-->
          <!--            <el-col :span="24">-->
          <!--              <el-form-item-->
          <!--                label-width="190px"-->
          <!--                label="分包商类型："-->
          <!--                prop="subconType"-->
          <!--              >-->
          <!--                <el-checkbox-group-->
          <!--                  v-model="extForm.subconChangeInfo.subconType"-->
          <!--                >-->
          <!--                  <el-checkbox label="总承包" name="0"></el-checkbox>-->
          <!--                  <el-checkbox label="专业分包" name="1"></el-checkbox>-->
          <!--                  <el-checkbox label="劳务分包商" name="2"></el-checkbox>-->
          <!--                  <el-checkbox label="其他" name="3"></el-checkbox>-->
          <!--                </el-checkbox-group>-->
          <!--              </el-form-item>-->
          <!--            </el-col>-->
          <!--          </el-row>-->
          <el-row
            v-if="
              extForm.subconChangeInfo.legalPersonIdCard !==
                extForm.subconAuthAccountInfo.authPersonIdCard
            "
          >
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="是否法人代表委托注册："
                prop="isLegalRegistration"
              >
                <el-radio-group v-model="isLegalRegistration">
                  <el-radio :label="0">是</el-radio>
                  <el-radio :label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              isLegalRegistration === 0 &&
                extForm.subconChangeInfo.legalPersonIdCard !==
                  extForm.subconAuthAccountInfo.authPersonIdCard
            "
          >
            <el-col :span="12">
              <el-form-item
                label-width="194px"
                label="法人代表授权委托书扫描件："
                prop="authCertificate"
              >
                <faren
                  :uploadUrl="extForm.subconAuthAccountInfo.authCertificate"
                  @faren="getUrlFr"
                ></faren>
              </el-form-item>
              <el-form-item label-width="194px" label="" prop="11">
                <span
                  style="color: #0089ef; cursor: pointer"
                  @click.stop="download"
                  >下载授权委托书模板</span
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="width: 1196px !important"></el-row>
        </div>
      </el-form>
    </div>
    <!-- 分包商基本信息 -->
    <div class="secondStep">
      <el-form
        :model="extForm.subconChangeInfo"
        :rules="rules2"
        ref="essentialInformation"
        label-width="60px"
        class="demo-ruleForm"
        style="margin-right: 300px"
      >
        <div class="title">
          <span></span>
          <div>分包商基本信息</div>
        </div>
        <div class="masterDataInformation" style="width:100%">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册地址："
                prop="registeredAddress"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.registeredAddress"
                  placeholder="请输入注册地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 待定 -->
            <el-col :span="12">
              <el-form-item label-width="190px" label="办公地址：">
                <el-input
                  v-model="extForm.subconChangeInfo.businessAddress"
                  placeholder="请输入办公地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="190px" label="历史名称：">
                <el-input
                  v-model="extForm.subconChangeInfo.historyName"
                  placeholder="请输入历史名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="190px" label="币种：">
                <!-- <el-input
                  v-model="essentialInformation.currency"
                  placeholder="请输入币种"
                ></el-input> -->
                <el-select
                  v-model="extForm.subconChangeInfo.currencyCode"
                  placeholder="请选择币种"
                  @change="forceUpdate"
                >
                  <el-option
                    v-for="item in qryCurrencyList"
                    :key="item.zcurrencycode"
                    :label="item.zcurrencyname"
                    :value="item.zcurrencycode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册资本（万元）："
                prop="registeredCapital"
              >
                <el-input
                  disabled
                  style="width: 277px"
                  v-model="extForm.subconChangeInfo.registeredCapital"
                  placeholder="请输入注册资本"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="190px" label="实缴资本（万元）：">
                <!-- prop="paidInCapital" -->
                <div class="verificationCode">
                  <el-input
                    maxlength="20"
                    type="number"
                    placeholder="请输入实缴资本"
                    style="width: 395px"
                    v-model.number="extForm.subconChangeInfo.paidInCapital"
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="纳税人类型："
                prop="taxpayerType"
              >
                <el-select
                  v-model="extForm.subconChangeInfo.taxpayerType"
                  placeholder="请选择"
                >
                  <el-option label="一般纳税人" value="0"></el-option>
                  <el-option label="小规模纳税人" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="公司成立时间："
                prop="companySetupTime"
              >
                <el-date-picker
                  v-model="extForm.subconChangeInfo.companySetupTimeCopy"
                  @change="changePicker2"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="190px" label="发证机关：">
                <el-input
                  v-model="extForm.subconChangeInfo.issuingAuthority"
                  placeholder="请输入发证机关"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="190px" label="实际控制人或大股东：">
                <el-input
                  v-model="extForm.subconChangeInfo.controllerPerson"
                  placeholder="请输入实际控制人或大股东"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="190px" label="公司人数：">
                <el-input
                  type="number"
                  v-model.number="extForm.subconChangeInfo.companySize"
                  placeholder="请输入公司人数"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="营业期限："
                prop="businessTime"
              >
                <el-date-picker
                  v-model="extForm.subconChangeInfo.businessTime"
                  @change="changePicker1"
                  :clearable="false"
                  align="right"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
                <label style="color: red">长期请选择2099年，可输入</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="190px"
                label="经营范围："
                prop="businessScope"
              >
                <el-input
                  style="width: 730px"
                  type="textarea"
                  :rows="3"
                  v-model="extForm.subconChangeInfo.businessScope"
                  placeholder="请输入营业范围"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="190px" label="关键技术：">
                <el-input
                  style="width: 730px"
                  type="textarea"
                  :rows="3"
                  v-model="extForm.subconChangeInfo.keyTechnology"
                  placeholder="请输入关键技术"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="安全生产许可证发证机关："
                prop="safetyLicenseIssAuth"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.safetyLicenseIssAuth"
                  placeholder="请输入安全生产许可证发证机关"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="安全生产许可证编号："
                prop="securityClearanceNumber"
              >
                <el-input
                  v-model="extForm.subconChangeInfo.securityClearanceNumber"
                  placeholder="请输入安全生产许可证编号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="190px"
                label="营业执照扫描件："
                prop="businessLicenseScan"
              >
                <upload
                  :uploadUrl="extForm.subconChangeInfo.businessLicenseScan"
                  @uploadUrl="getUrl"
                ></upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="24">
              <el-form-item
                label-width="190px"
                label="安全生产许可证："
                prop="safetyLicenseEnclosure"
              >
                <anquan
                  :uploadUrl="extForm.subconChangeInfo.safetyLicenseEnclosure"
                  @anquan="getUrlAq"
                ></anquan>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row> -->
          <!-- <el-col :span="12" class="addTabIndex"> -->
          <!-- <el-form-item -->
          <!-- label-width="190px"
                label="安全生产许可证有效期："
                prop="safetyLicenseValidityStart"
              >
                <el-date-picker
                  v-model="extForm.subconChangeInfo.safetyLicenseValidityStart"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker> -->
          <!--                <el-date-picker-->
          <!--                  v-model="extForm.subconChangeInfo.safeTime"-->
          <!--                  @change="safePicker"-->
          <!--                  :clearable="false"-->
          <!--                  align="right"-->
          <!--                  type="daterange"-->
          <!--                  value-format="yyyy-MM-dd"-->
          <!--                  range-separator="至"-->
          <!--                  start-placeholder="开始日期"-->
          <!--                  end-placeholder="结束日期"-->
          <!--                  :picker-options="pickerOptions"-->
          <!--                >-->
          <!--                </el-date-picker>-->
          <!-- </el-form-item> -->
          <!-- </el-col> -->
          <!-- <el-col :span="12" class="addTabIndex">
              <el-form-item
                label-width="190px"
                label="安全生产许可证截止期："
                prop="safetyLicenseValidityEnd"
              >
                <el-date-picker
                  v-model="extForm.subconChangeInfo.safetyLicenseValidityEnd"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
          <!-- </el-row> -->
          <!-- <el-row>
            <el-col :span="24" >
              <el-form-item
                label-width="190px"
                label="分包商专业："
                prop="subconSubject"
              >
                <subcontractorSpecialty
                  ref="subcontractorSpecialty"
                  :extTable="extForm.subconSubjectChange"
                ></subcontractorSpecialty>
              </el-form-item>
            </el-col>
          </el-row>-->
        </div>
      </el-form>
    </div>
    <!-- 资质列表 -->
    <!-- <div class="secondStep">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{}"
        ref="qualificationList"
      >
        <div class="title" style="left: -100px">
          <span></span>
          <div>资质列表</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule"
              :mode="extForm.subconQualificationsChange"
              label-width=""
              label=""
              prop="list"
            >
              <qualificationList
                :extTable="extForm.subconQualificationsChange"
                ref="qualificationListRule"
              ></qualificationList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <span style="float: left;color: red">*</span>
            <el-form-item
              style="float: left;width: 90%;margin-top: -5px;margin-left: 5px;"
              :rules="qualificationListRule"
              :mode="extForm.subconQualificationsChange"
              label-width=""
              label="资质证书附件："
              prop="list"
            >
              <qualificationCertificate
                :uploadUrl="
                  extForm.subconQualificationsChange &&
                  extForm.subconQualificationsChange.length
                    ? extForm.subconQualificationsChange[0].attribute10
                    : ''
                "
                @qualifications="qualifications"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div> -->
    <!-- 主要设备 -->
    <!-- <div class="secondStep">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{ extForm }"
        ref="majorEquipment"
        :rules="majorEquipmentRules"
      >
        <div class="title" style="left: -100px">
          <span></span>
          <div>主要设备</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item prop="list">
              <majorEquipment
                ref="majorEquipmentRules"
                :extTable="extForm.subconDeviceInfoChange"
              ></majorEquipment>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              label-width=""
              label="自有设备证明材料："
              prop="files"
            >
              <qualificationCertificate
                :uploadUrl="
                  extForm.subconDeviceInfoChange &&
                  extForm.subconDeviceInfoChange.length
                    ? extForm.subconDeviceInfoChange[0].attribute10
                    : ''
                "
                @qualifications="deviceFile"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div> -->
    <!-- 主要管理人员 -->
    <div class="secondStep">
      <el-form label-width="" class="demo-ruleForm" ref="personnelManagements">
        <div class="title" style="left: -100px">
          <span></span>
          <div>主要管理人员</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <!-- <el-form-item label-width="" label="" prop="subconManagePerson"> -->
            <personnelManagement
              :extTable="extForm.subconManagePersonChange"
              ref="personnelManagement"
            ></personnelManagement>
            <!-- </el-form-item> -->
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
        <el-row>
          <el-col>
            <el-form-item label-width="190px" label=" ">
              <el-button @click="submitForm('ruleForm')">下一步</el-button>
              <el-button class="stopBtn" @click="stopForm()">暂存</el-button>
              <el-button class="lastBtn" @click="lastStep()">上一步</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog
      title="选择企业性质"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <cooperativeUnit
        :treeData="listSubconBaseSubjectList"
        ref="msgFormSon"
      ></cooperativeUnit>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getTreeItem">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择往来单位类别"
      :visible.sync="categoryDialogVisible"
      width="30%"
      center
    >
      <subconCategoryTree
        :treeData="listSubconCategory"
        ref="msgFormCategory"
      ></subconCategoryTree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="categoryDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getCategoryTreeItem">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择往来单位性质"
      :visible.sync="natureDialogVisible"
      width="30%"
      center
    >
      <subcon-nature
        :treeData="listSubconNature"
        ref="msgFormNature"
      ></subcon-nature>
      <span slot="footer" class="dialog-footer">
        <el-button @click="natureDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getNatureTreeItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upload from "../components/upload.vue";
import frontPhotoOfIdCard from "../components/frontPhotoOfIdCard.vue";
import reversePhotoOfIdCard from "../components/reversePhotoOfIdCard.vue";
// import qualificationCertificate from "../components/qualificationCertificate.vue";

import anquan from "../components/anquan.vue";
import faren from "../components/faren.vue";

import cooperativeUnit from "../components/cooperativeUnit.vue";
import subconCategoryTree from "../components/subconCategoryTree.vue";
import subconNature from "../components/subconNatureTree.vue";
// import upload1 from "../upload.vue";
// 主要设备
// import majorEquipment from "../components/majorEquipment.vue";
// 人员管理
import personnelManagement from "../components/personnelManagement.vue";
// 资历列表
import qualificationList from "../components/qualificationList.vue";
//
import scmaAreaSelector from "../components/scmaAreaSelector";
//
import regionConfig from "../mixins/regionConfig";
// 分包商专业
// import subcontractorSpecialty from "../components/subcontractorSpecialty.vue";
// 手动上传
// 接口总览
import {
  getCountryList,
  getAdministrationList,
  // findAreaAddress,
  listSubconCategory,
  listSubconNature,
  listSubconUnitNaturePage,
  qryCurrencyType,
  registerSubconChangeInfos,
  getSubconConfigByCode
} from "@/api/subcontractor-register";
import addUrlPerFix from "../../../../utils/index";
export default {
  mixins: [regionConfig],
  props: {
    extForm: {}
  },
  components: {
    upload,
    // majorEquipment,
    personnelManagement,
    qualificationList,
    // subcontractorSpecialty,
    frontPhotoOfIdCard,
    reversePhotoOfIdCard,
    cooperativeUnit,
    anquan,
    faren,
    // qualificationCertificate,
    subconCategoryTree,
    subconNature,
    scmaAreaSelector
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return false;
        }
      };
    },
    pickerOptions1() {
      return {
        disabledDate: function(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      };
    }
  },
  mounted() {
    if (this.extForm.subconChangeInfo.cardType === undefined) {
      this.extForm.subconChangeInfo.cardType = String(0);
    }

    if (this.extForm.subconChangeInfo.currencyCode === undefined) {
      this.extForm.subconChangeInfo.currencyCode = String(156);
      this.currencyName = "人民币元";
    } else {
      this.currencyName = this.extForm.subconChangeInfo.currency;
    }

    if (this.extForm.subconAuthAccountInfo.cardType === undefined) {
      this.extForm.subconAuthAccountInfo.cardType = String(0);
    }

    // 往来单位类别
    listSubconCategory({
      business: "",
      attribute1: true,
      isDelete: 0,
      baseAppId: 100065
      // lastStatus: 1
    }).then(res => {
      if (res.data.code === "0") {
        this.listSubconCategory = res.data.data;
      }
    });
    // 往来单位性质
    listSubconNature({
      business: "",
      attribute1: true,
      isDelete: 0,
      baseAppId: 100065,
      lastStatus: 1
    }).then(res => {
      if (res.data.code === "0") {
        this.listSubconNature = res.data.data;
      }
    });
    this.$refs.myCascader.inputValue = this.extForm.subconChangeInfo
      ? this.extForm.subconChangeInfo.inputValue
      : "";
    // 企业性质
    listSubconUnitNaturePage({
      attribute1: "true",
      baseAppId: 100065,
      business: "",
      isDelete: 0
    }).then(res => {
      this.listSubconBaseSubjectList = res.data.data;
    });

    // 币种
    qryCurrencyType({
      pageNo: 1,
      pageSize: 1000
    }).then(res => {
      this.qryCurrencyList = res.data.data.rows;
    });
    // 授权书模板id
    getSubconConfigByCode({ configCode: "01" }).then(res => {
      this.uploadId = res.data.data.configValue;
    });
    this.handleCountry();
  },
  methods: {
    handleCountry() {
      this.defaultArea = [];
      var tmp = this.extForm.subconChangeInfo.inputValue.split("/");
      for (let i = 0; i < this.extForm.subconChangeInfo.countrys.length; i++) {
        try {
          this.defaultArea.push({
            level: i + 1,
            name: tmp[i],
            code: this.extForm.subconChangeInfo.countrys[i]
          });
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    },
    // 往来单位性质 修改
    getCategoryCode(val) {
      this.extForm.subconChangeInfo.subconCategoryCode = val;
      this.listSubconCategory.forEach(item => {
        if (item.categoryCode === val) {
          this.extForm.subconChangeInfo.subconCategoryName = item.name;
        }
      });
    },
    getNatureCode(val) {
      this.extForm.subconChangeInfo.subconNatureCode = val;
      this.listSubconNature.forEach(item => {
        if (item.natureCode === val) {
          this.extForm.subconChangeInfo.subconNatureName = item.name;
        }
      });
    },
    getTreeItem() {
      let treeItem = this.$refs["msgFormSon"].subjectObj;
      if (!treeItem || (treeItem && treeItem.lastStatus !== 1)) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点以及下级节点数据,并且是末级数据",
          ccuiCustom: true
        });
        return false;
      }
      this.$set(this.extForm.subconChangeInfo, "comNatureName", "");
      this.$set(
        this.extForm.subconChangeInfo,
        "comNatureCode",
        treeItem.natureCode
      );
      this.$set(this.extForm.subconChangeInfo, "comNatureName", treeItem.name);
      this.centerDialogVisible = false;
    },
    getCategoryTreeItem() {
      let treeItem = this.$refs["msgFormCategory"].categoryObj;
      if (!treeItem || (treeItem && treeItem.lastStatus !== 1)) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点以及下级节点数据,并且是末级数据",
          ccuiCustom: true
        });
        return false;
      }
      this.$set(this.extForm.subconChangeInfo, "subconCategoryName", "");
      this.$set(
        this.extForm.subconChangeInfo,
        "subconCategoryCode",
        treeItem.categoryCode
      );
      this.$set(
        this.extForm.subconChangeInfo,
        "subconCategoryName",
        treeItem.name
      );
      this.categoryDialogVisible = false;
    },
    getNatureTreeItem() {
      let treeItem = this.$refs["msgFormNature"].natureObj;
      if (!treeItem || (treeItem && treeItem.lastStatus !== 1)) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点以及下级节点数据,并且是末级数据",
          ccuiCustom: true
        });
        return false;
      }
      this.$set(this.extForm.subconChangeInfo, "subconNatureName", "");
      this.$set(
        this.extForm.subconChangeInfo,
        "subconNatureCode",
        treeItem.natureCode
      );
      this.$set(
        this.extForm.subconChangeInfo,
        "subconNatureName",
        treeItem.name
      );
      this.natureDialogVisible = false;
    },
    getUrl(url) {
      this.extForm.subconChangeInfo.businessLicenseScan = url;
    },
    getUrlZm(url) {
      this.extForm.subconChangeInfo.legalPersonCardFront = url;
    },
    getUrlFm(url) {
      this.extForm.subconChangeInfo.legalPersonCardBack = url;
    },
    getUrlFr(url) {
      this.extForm.subconAuthAccountInfo.authCertificate = url;
      this.$set(this.extForm.subconChangeInfo, "authCertificate", url);
    },
    forceUpdate(value) {
      let obj = {};
      obj = this.qryCurrencyList.find(item => {
        return item.zcurrencycode === value;
      });
      this.currencyName = obj.zcurrencyname;
    },
    download() {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.downloadUrl}?uploadId=` + this.uploadId; //4106
      openUrl.setAttribute("download", "授权委托书");
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    // qualifications(url) {
    //   if (
    //     this.extForm.subconQualificationsChange &&
    //     this.extForm.subconQualificationsChange.length <= 0
    //   ) {
    //     this.extForm.subconQualificationsChange.push({
    //       id: 1
    //     });
    //   }
    //   this.extForm.subconQualificationsChange[0].qualificationEnclosure = url;
    //   this.extForm.subconQualificationsChange[0].attribute10 = url;
    // },
    // deviceFile(url) {
    //   if (
    //     this.extForm.subconDeviceInfoChange &&
    //     this.extForm.subconDeviceInfoChange.length <= 0
    //   ) {
    //     this.extForm.subconDeviceInfoChange.push({
    //       id: 1
    //     });
    //   }
    //   this.extForm.subconDeviceInfoChange[0].attribute5 = url;
    //   this.extForm.subconDeviceInfoChange[0].attribute10 = url;
    // },
    // getUrlAq(url) {
    //   this.extForm.subconChangeInfo.safetyLicenseEnclosure = url;
    // },
    // 暂存
    stopForm() {
      // var majorEquipmentTmp = [];
      // if (
      //   this.extForm.subconDeviceInfoChange &&
      //   this.extForm.subconDeviceInfoChange.length > 0
      // ) {
      //   this.extForm.subconDeviceInfoChange.forEach(e => {
      //     var tmp = Object.assign({}, e);
      //     tmp.buyYearCopy = "";
      //     tmp.createTime = "";
      //     tmp.updateTime = "";
      //     tmp.attribute10 = "";
      //     tmp.attribute5 = this.extForm.subconDeviceInfoChange[0].attribute5
      //       ? this.extForm.subconDeviceInfoChange[0].attribute5.uploadId
      //       : "";
      //     majorEquipmentTmp.push(tmp);
      //   });
      // }
      /* if (
        this.extForm.subconSubjectChange &&
        this.extForm.subconSubjectChange.length > 0
      ) {
        this.extForm.subconSubjectChange.forEach((e) => {
          e.createTime = "";
        });
      }*/

      // var qualificationListTmp = [];
      // if (
      //   this.extForm.subconQualificationsChange &&
      //   this.extForm.subconQualificationsChange.length > 0
      // ) {
      //   this.extForm.subconQualificationsChange.forEach(e => {
      //     var tmp = Object.assign({}, e);
      //     tmp.vaildTime = "";
      //     tmp.createTime = "";
      //     tmp.attribute10 = "";
      //     tmp.updateTime = "";
      //     tmp.qualificationEnclosure = this.extForm
      //       .subconQualificationsChange[0].qualificationEnclosure
      //       ? this.extForm.subconQualificationsChange[0].qualificationEnclosure
      //           .uploadId
      //       : "";
      //     qualificationListTmp.push(tmp);
      //   });
      // }

      const tmpObj = Object.assign({}, this.extForm.subconChangeInfo);
      tmpObj.yesNo = tmpObj.yesNo === "是" ? 0 : 1;

      // tmpObj.subconType = [];
      // qualificationListTmp.forEach(function(e) {
      //   tmpObj.subconType.push(e.attribute3)
      // })
      //数组去重
      function unique(arr) {
        return Array.from(new Set(arr));
      }
      if (tmpObj.subconType) {
        tmpObj.subconType = unique(tmpObj.subconType).join();
      }
      tmpObj.currency = this.currencyName;
      tmpObj.legalPersonCardValidityStart1 = "";
      tmpObj.businessTime = "";
      tmpObj.updateTime = "";
      tmpObj.companySetupTimeCopy = "";
      tmpObj.subconRegisterType = "03";
      // that
      tmpObj.legalPersonCardFront = this.extForm.subconChangeInfo
        .legalPersonCardFront
        ? this.extForm.subconChangeInfo.legalPersonCardFront.uploadId
        : "";
      tmpObj.legalPersonCardBack = this.extForm.subconChangeInfo
        .legalPersonCardBack
        ? this.extForm.subconChangeInfo.legalPersonCardBack.uploadId
        : "";
      // tmpObj.safetyLicenseEnclosure = this.extForm.subconChangeInfo
      //   .safetyLicenseEnclosure
      //   ? this.extForm.subconChangeInfo.safetyLicenseEnclosure.uploadId
      //   : "";
      tmpObj.businessLicenseScan = this.extForm.subconChangeInfo
        .businessLicenseScan
        ? this.extForm.subconChangeInfo.businessLicenseScan.uploadId
        : "";

      var personnelManagementsList = [];
      if (
        this.extForm.subconManagePersonChange &&
        this.extForm.subconManagePersonChange.length > 0
      ) {
        this.extForm.subconManagePersonChange.forEach(e => {
          var current = Object.assign({}, e);
          current.yesNo = current.yesNo === "是" ? 0 : 1;
          current.createTime = "";
          current.updateTime = "";
          personnelManagementsList.push(current);
        });
      }
      this.extForm.subconAuthAccountInfo.createTime = "";
      this.extForm.subconAuthAccountInfo.updateTime = "";

      var tmpObj1 = Object.assign({}, this.extForm.subconAuthAccountInfo);
      tmpObj1.authCertificate = tmpObj1.authCertificate.uploadId;

      this.extForm.subconDeviceInfoChange.createTime = "";
      tmpObj.createTime = "";
      tmpObj.updateTime = "";

      if (sessionStorage.getItem("type") === null) {
        tmpObj1.attribute10 = "";
      } else {
        tmpObj1.attribute10 = sessionStorage.getItem("type");
      }
      /*if(tmpObj1.authPersonIdCard===tmpObj.legalPersonIdCard){
        tmpObj1.attribute10 = "1";
      }*/
      this.formLoading = true;
      registerSubconChangeInfos({
        subconAuthAccountInfo: tmpObj1,
        subconChangeInfo: tmpObj,
        // 主要管理人员
        subconManagePersonChange: personnelManagementsList
        // 主要设备变更
        // subconDeviceInfoChange: majorEquipmentTmp,
        // 资质列表
        // subconQualificationsChange: qualificationListTmp
        //subconSubjectChange: this.extForm.subconSubjectChange,
      }).then(
        res => {
          this.formLoading = false;
          if (res.data.data.code === "0") {
            this.extForm.subconChangeInfo.id = res.data.data.changeInfoId;
            this.$message({
              showClose: true,
              type: "success",
              message: "暂存成功",
              ccuiCustom: true
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.data.message,
              ccuiCustom: true
            });
          }
          sessionStorage.removeItem("type");
        },
        error => {
          this.formLoading = false;
        }
      );
    },
    // 下一步
    submitForm() {
      // 校验有效期时间
      if (
        this.extForm.subconChangeInfo.legalPersonCardValidityEnd &&
        new Date().getTime() >=
          new Date(
            this.extForm.subconChangeInfo.legalPersonCardValidityEnd
          ).getTime()
      ) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "法人证件号有效期无效",
          ccuiCustom: true
        });
        return false;
      }
      if (
        this.extForm.subconChangeInfo.businessEndTime &&
        new Date().getTime() >=
          new Date(this.extForm.subconChangeInfo.businessEndTime).getTime()
      ) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "营业期限有效期无效",
          ccuiCustom: true
        });
        return false;
      }
      // if (
      //   this.extForm.subconChangeInfo.businessEndTime &&
      //   this.extForm.subconChangeInfo.businessEndTime
      // ) {
      //   this.$message({
      //     type: "warning",
      //     showClose: true,
      //     message: "请输入营业期限",
      //     ccuiCustom: true
      //   });
      //   return false;
      // }
      // if (
      //   this.extForm.subconChangeInfo.safetyLicenseValidityEnd &&
      //   new Date().getTime() >=
      //     new Date(
      //       this.extForm.subconChangeInfo.safetyLicenseValidityEnd
      //     ).getTime()
      // ) {
      //   this.$message({
      //     type: "warning",
      //     showClose: true,
      //     message: "安全生产许可证有效期无效",
      //     ccuiCustom: true
      //   });
      //   return false;
      // }
      // if (this.extForm.subconQualificationsChange.length <= 0) {
      //   this.$message({
      //     type: "warning",
      //     showClose: true,
      //     message: "资质列表不能为空",
      //     ccuiCustom: true
      //   });
      //   return false;
      // }
      // this.$refs.majorEquipmentRules.ruleFun();
      this.$refs.personnelManagement.ruleFun();
      // this.$refs.qualificationListRule.ruleFun();
      // this.$refs.subcontractorSpecialty.ruleFun();
      const p1 = new Promise((resolve, reject) => {
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            this.formTip.flag = true;
            resolve();
          } else {
            this.formTip.flag = false;
          }
        });
      });
      const p2 = new Promise((resolve, reject) => {
        this.$refs["accountInformation"].validate(valid => {
          if (valid) {
            this.formTip.flag1 = true;
            resolve();
          } else {
            this.formTip.flag1 = false;
          }
        });
      });

      const p3 = new Promise((resolve, reject) => {
        this.$refs["essentialInformation"].validate(valid => {
          if (valid) {
            this.formTip.flag2 = true;
            resolve();
          } else {
            this.formTip.flag2 = false;
          }
        });
      });
      let { flag, flag1, flag2 } = this.formTip;
      if (!flag && !flag1 && !flag2) {
        this.$emit("open");
      }
      // let that = this;
      Promise.all([p1, p2, p3]).then(async () => {
        // var majorEquipmentTmp = [];
        // if (
        //   this.extForm.subconDeviceInfoChange &&
        //   this.extForm.subconDeviceInfoChange.length > 0
        // ) {
        //   this.extForm.subconDeviceInfoChange.forEach(e => {
        //     var tmp = Object.assign({}, e);
        //     tmp.createTime = "";
        //     tmp.updateTime = "";
        //     tmp.buyYearCopy = "";
        //     tmp.attribute10 = "";
        //     tmp.attribute5 = this.extForm.subconDeviceInfoChange[0].attribute5
        //       ? this.extForm.subconDeviceInfoChange[0].attribute5.uploadId
        //       : "";
        //     majorEquipmentTmp.push(tmp);
        //   });
        // }

        // var qualificationListTmp = [];
        // if (
        //   this.extForm.subconQualificationsChange &&
        //   this.extForm.subconQualificationsChange.length > 0
        // ) {
        //   this.extForm.subconQualificationsChange.forEach(e => {
        //     var tmp = Object.assign({}, e);
        //     tmp.vaildTime = "";
        //     tmp.createTime = "";
        //     tmp.updateTime = "";
        //     tmp.attribute10 = "";
        //     tmp.qualificationEnclosure = this.extForm
        //       .subconQualificationsChange[0].qualificationEnclosure
        //       ? this.extForm.subconQualificationsChange[0]
        //           .qualificationEnclosure.uploadId
        //       : "";
        //     qualificationListTmp.push(tmp);
        //   });
        // }

        /* if (
          this.extForm.subconSubjectChange &&
          this.extForm.subconSubjectChange.length > 0
        ) {
          this.extForm.subconSubjectChange.forEach((e) => {
            e.createTime = "";
          });
        }*/
        const tmpObj = Object.assign({}, this.extForm.subconChangeInfo);
        tmpObj.legalPersonCardValidityStart1 = "";
        // tmpObj.subconType = tmpObj.subconType.join();
        // tmpObj.subconType = [];
        // qualificationListTmp.forEach(function(e) {
        //   tmpObj.subconType.push(e.attribute3)
        // })
        //数组去重
        function unique(arr) {
          return Array.from(new Set(arr));
        }
        if (tmpObj.subconType) {
          tmpObj.subconType = unique(tmpObj.subconType).join();
        }
        tmpObj.currency = this.currencyName;
        tmpObj.businessTime = "";
        tmpObj.companySetupTimeCopy = "";
        tmpObj.createTime = "";
        tmpObj.updateTime = "";
        tmpObj.checkState = 2;
        tmpObj.registeredType = 0;
        tmpObj.subconRegisterType = "03";
        tmpObj.legalPersonCardFront = this.extForm.subconChangeInfo.legalPersonCardFront.uploadId;
        tmpObj.legalPersonCardBack = this.extForm.subconChangeInfo.legalPersonCardBack.uploadId;
        // tmpObj.safetyLicenseEnclosure = this.extForm.subconChangeInfo.safetyLicenseEnclosure.uploadId;
        tmpObj.businessLicenseScan = this.extForm.subconChangeInfo.businessLicenseScan.uploadId;

        var personnelManagementsList = [];
        if (
          this.extForm.subconManagePersonChange &&
          this.extForm.subconManagePersonChange.length > 0
        ) {
          this.extForm.subconManagePersonChange.forEach(e => {
            var current = Object.assign({}, e);
            current.yesNo = current.yesNo === "是" ? 0 : 1;
            current.createTime = "";
            current.updateTime = "";
            personnelManagementsList.push(current);
          });
        }
        this.extForm.subconAuthAccountInfo.createTime = "";

        this.extForm.subconAuthAccountInfo.updateTime = "";

        var tmpObj1 = Object.assign({}, this.extForm.subconAuthAccountInfo);
        tmpObj1.authCertificate = tmpObj1.authCertificate.uploadId;

        tmpObj.yesNo = tmpObj.yesNo === "是" ? 0 : 1;
        this.formLoading = true;
        registerSubconChangeInfos({
          subconAuthAccountInfo: tmpObj1,
          subconChangeInfo: tmpObj,
          // 主要管理人员
          subconManagePersonChange: personnelManagementsList
          // 主要设备变更
          // subconDeviceInfoChange: majorEquipmentTmp,
          // 资质列表
          // subconQualificationsChange: qualificationListTmp
          // 分包商专业
          // subconSubjectChange: this.extForm.subconSubjectChange,
        })
          .then(res => {
            console.log('------------------------------',res.data.data.code);
            let { code, message } = res.data.data;
            if (res.data.data.code === "0") {
              this.extForm.subconChangeInfo.id = res.data.data.changeInfoId;
              this.$emit("getStep", 2);
            } else {
              this.$message({
                message: message,
                type: code === "0" ? "success" : "error"
              });
            }
            this.formLoading = false;
          })
          .catch(e => {
            this.formLoading = false;
            console.log(e);
          });
      });
    },

    // 上一步
    lastStep() {
      this.$confirm("如需跳转上一步！则会刷新数据", "确认跳转", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          location.reload();
        })
        .catch(action => {});
    },

    // 获取省级联动数据
    handleChange(val) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.getLabelValue();
        });
      }, 100);
    },
    getLabelValue() {
      this.extForm.subconChangeInfo.province = "";
      this.extForm.subconChangeInfo.city = "";
      this.extForm.subconChangeInfo.county = "";
      this.extForm.subconChangeInfo.attribute2 = "";
      const obj = this.$refs["myCascader"].getCheckedNodes();
      this.extForm.subconChangeInfo.country = obj[0].pathLabels[0];
      this.extForm.subconChangeInfo.province = obj[0].pathLabels[1];
      this.extForm.subconChangeInfo.city = obj[0].pathLabels[2];
      this.extForm.subconChangeInfo.county = obj[0].pathLabels[3];
      this.extForm.subconChangeInfo.attribute2 = JSON.stringify(obj[0].path);
    },
    // 获取省级联动数据 结束

    // safePicker(date) {
    //   if (date) {
    //     this.extForm.subconChangeInfo.safetyLicenseValidityStart = this.getDate(
    //       date[0]
    //     );
    //     this.extForm.subconChangeInfo.safetyLicenseValidityEnd = this.getDate(
    //       date[1]
    //     );
    //   }
    // },
    changePicker(date) {
      if (date) {
        this.extForm.subconChangeInfo.legalPersonCardValidityStart = this.getDate(
          date[0]
        );
        this.extForm.subconChangeInfo.legalPersonCardValidityEnd = this.getDate(
          date[1]
        );
      }
    },
    changePicker1(date) {
      if (date) {
        this.extForm.subconChangeInfo.businessStartTime = this.getDate(date[0]);
        this.extForm.subconChangeInfo.businessEndTime = this.getDate(date[1]);
      }
    },
    changePicker2(date) {
      if (date) {
        this.extForm.subconChangeInfo.companySetupTime = date;
      }
    },

    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    }
  },
  data() {
    return {
      formTip: {
        flag: false,
        flag1: false,
        flag2: false,
        flag3: false
      },
      isLegalRegistration: 0,
      currencyName: "",
      downloadUrl: this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL +
          "/apis/sra/reg/users/signup/downloadByUploadId"
      ), //下载文件
      // loading开关
      formLoading: false,
      // 往来单位类别
      listSubconCategory: [],
      // 往来单位性质
      listSubconNature: [],
      categoryDialogVisible: false,
      centerDialogVisible: false,
      natureDialogVisible: false,
      listSubconBaseSubjectList: [],
      // 币种列表
      qryCurrencyList: [],
      uploadId: "",
      propsPlace: {
        checkStrictly: true,
        // checkStrictly: true,
        expandTrigger: "hover",
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            getCountryList({
              zcountryname: "中国",
              pageNo: 1,
              pageSize: 1000
            }).then(response => {
              const cities = response.data.data.rows.map((value, i) => ({
                value: value.zcountrycode,
                label: value.zcountryname,
                leaf: false
              }));
              resolve(cities);
            });
          }
          if (node.level === 1) {
            getAdministrationList({
              zaddvsup: "0",
              pageNo: 1,
              pageSize: 1000
            }).then(response => {
              const cities = [];
              response.data.data.rows.forEach(item => {
                cities.push({
                  value: item.zaddvscode,
                  label: item.zaddvsname,
                  leaf: false
                });
              });
              resolve(cities);
            });
          }
          if (node.level > 1 && node.level < 4) {
            getAdministrationList({
              zaddvsup: node.value,
              pageNo: 1,
              pageSize: 1000
            }).then(response => {
              const areas = response.data.data.rows.map((value, i) => ({
                value: value.zaddvscode,
                label: value.zaddvsname,
                leaf: node.level === 3
              }));
              resolve(areas);
            });
          }
        }
      },

      rules: {
        subconShortName: [
          { required: true, message: "请输入分包商简称", trigger: "change" }
        ],
        yesNo: [
          {
            required: true,
            message: "请选择是否是内部单位",
            trigger: "change"
          }
        ],
        yesNoCopy: [
          {
            required: true,
            message: "请选择是否是内部单位",
            trigger: "change"
          }
        ],
        countrys: [
          { required: true, message: "请输入所在地", trigger: "change" }
        ],
        subconName: [
          { required: true, message: "请输入分包商名称", trigger: "change" }
        ],
        cooUnitName: [
          { required: true, message: "请输入合作单位", trigger: "change" }
        ],
        subconCode: [
          {
            required: true,
            message: "请输入往来单位主数据编码",
            trigger: "change"
          }
        ],
        cooUnitCode: [
          {
            required: true,
            message: "请输入机构主数据编码",
            trigger: "change"
          }
        ],
        unifiedCreditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change"
          }
        ],
        comNatureName: [
          {
            required: true,
            message: "请选择企业性质",
            trigger: "change"
          }
        ],
        subconCategoryName: [
          {
            required: true,
            message: "请选择往来单位类别",
            trigger: "change"
          }
        ],
        subconNatureName: [
          {
            required: true,
            message: "请选择往来单位性质",
            trigger: "change"
          }
        ],
        // subconUsName: [
        //   {
        //     required: false,
        //     pattern: /^[A-Za-z]*(\s[A-Za-z]*)*$/,
        //     message: "只支持输入英文名称"
        //   }
        // ],
        legalPersonPhone: [
          { required: true, message: "请输入法人电话号码", trigger: "change" },
          {
            pattern: /^\d{11}$/,
            message: "手机号码输入错误"
          }
        ],
        cardType: [
          { required: true, message: "请输入法人证件类型", trigger: "blur" }
        ],
        legalPersonName: [
          { required: true, message: "请输入法人姓名", trigger: "change" },
          {
            required: false,
            pattern: /^[\u4e00-\u9fa5]{2,18}$/,
            message: "请输入2-18个中文汉字"
          }
        ],
        legalPersonCardValidityStart: [
          {
            required: true,
            message: "请输入法人证件号码有效期",
            trigger: "change"
          }
        ],
        legalPersonCardValidityEnd: [
          {
            required: true,
            message: "请输入法人证件号码截止期",
            trigger: "change"
          }
        ],
        legalPersonIdCard: [
          { required: true, message: "请输入法人证件号码", trigger: "change" },
          /*{
            required: true,
            /!*pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,*!/
            pattern: /^\w{1,18}$/,
            message: "请输入正确的身份证号码",
            trigger: ["blur"]

          }*/
          {
            min: 9,
            max: 18,
            required: true,
            message: "请输入法人证件号码",
            trigger: "blur"
          }
        ],
        legalPersonCardFront: [
          {
            required: true,
            message: "请输入法人身份证扫描件正面",
            trigger: ["blur", "change"]
          }
        ],
        legalPersonCardBack: [
          {
            required: true,
            message: "请输入法人身份证扫描件反面",
            trigger: ["blur", "change"]
          }
        ]
      },
      // 注册账户信息校验
      rules1: {
        authUserName: [
          {
            required: true,
            message: "请输入注册联系人姓名",
            trigger: "change"
          },
          {
            required: false,
            pattern: /^[\u4e00-\u9fa5]{2,18}$/,
            message: "请输入2-18个中文汉字"
          }
        ],
        cardType: [
          {
            required: true,
            message: "请输入注册联系人证件类型",
            trigger: "change"
          }
        ],
        authPersonIdCard: [
          {
            required: true,
            message: "请输入注册联系人证件号码",
            trigger: "blur"
          },
          /*{
            required: true,
            //pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            pattern: /^\w{1,18}$/,
            message: "请输入正确的身份证号码",
            trigger: ["blur"]
          },*/
          {
            min: 9,
            max: 18,
            required: true,
            message: "请输入法人证件号码",
            trigger: "blur"
          }
        ],

        registerEmail: [
          { required: true, message: "请输入注册邮箱", trigger: "change" },
          {
            required: false,
            pattern: /^\w{2,12}@[a-z0-9]+\.[a-z]{2,4}$/,
            message: "只支持输入邮箱格式",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入注册联系人手机号",
            trigger: "change"
          },
          {
            pattern: /^\d{11}$/,
            message: "手机号码输入错误",
            trigger: "blur"
          }
        ],
        // subconType: [
        //   { required: true, message: "请输入分包商类型", trigger: "change" },
        // ],
        authCertificate: [
          {
            required: true,
            message: "请上传法人代表授权委托书扫描件",
            trigger: "change"
          }
        ]
      },
      // 分包商基本信息校验
      rules2: {
        businessAddress: [
          { required: true, message: "请输入办公地址", trigger: "change" }
        ],
        // safetyLicenseIssAuth: [
        //   {
        //     required: true,
        //     message: "请输入安全生产许可证发证机关",
        //     trigger: "change"
        //   }
        // ],
        // securityClearanceNumber: [
        //   {
        //     required: true,
        //     message: "请输入安全生产许可证编号",
        //     trigger: "change"
        //   }
        // ],
        historyName: [
          { required: true, message: "请输入历史名称", trigger: "change" }
        ],
        registeredAddress: [
          { required: true, message: "请输入注册地址", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入历史名称", trigger: "change" }
        ],

        registeredCapital: [
          { required: false, message: "请输入注册资本", trigger: "change" }
        ],
        paidInCapital: [
          { required: false, message: "请输入实缴资本", trigger: "change" },
          {
            required: false,
            type: "number",
            message: "实缴资本必须为数字值",
            trigger: "blur"
          }
        ],
        taxpayerType: [
          { required: true, message: "请输入纳税人类型", trigger: "change" }
        ],
        companySetupTime: [
          { required: true, message: "请输入公司成立时间", trigger: "change" }
        ],
        businessStartTime: [
          {
            required: true,
            message: "请输入营业期限",
            trigger: ["change", "blur"]
          }
        ],
        businessTime: [
          {
            required: true,
            message: "请输入营业期限",
            trigger: ["change", "blur"]
          }
        ],
        businessEndTime: [
          { required: true, message: "请输入公司营业期限", trigger: "change" }
        ],
        businessScope: [
          { required: true, message: "请输入经营范围", trigger: "change" }
        ],
        keyTechnology: [
          { required: true, message: "请输入关键技术", trigger: "blur" }
        ],
        issuingAuthority: [
          { required: true, message: "请输入发证机关", trigger: "change" }
        ],
        controllerPerson: [
          {
            required: true,
            message: "请输入实际控制人或大股东",
            trigger: "change"
          }
        ],
        companySize: [
          { required: true, message: "请输入公司人数", trigger: "change" },
          {
            required: true,
            pattern: /^\d{1, 11}$/,
            message: "只能是整数,格式不对",
            trigger: "change"
          }
        ],
        businessLicenseScan: [
          {
            required: true,
            message: "请输入营业执照扫描件",
            trigger: "change"
          }
        ]
        // safetyLicenseEnclosure: [
        //   { required: true, message: "请输入安全生产许可证", trigger: "change" }
        // ],
        // safetyLicenseValidityStart: [
        //   {
        //     required: true,
        //     message: "请选择安全生产许可证有效期",
        //     trigger: "change"
        //   }
        // ],
        // safetyLicenseValidityEnd: [
        //   {
        //     required: true,
        //     message: "请选择安全生产许可证截止期",
        //     trigger: "change"
        //   }
        // ]
      },
      // 列表校验
      // qualificationListRule: {
      //   list: [
      //     { required: true, message: "资历列表不能为空", trigger: "change" }
      //   ]
      // },
      // majorEquipmentRules: {
      //   list: [
      //     { required: true, message: "设备类表不能为空", trigger: "change" }
      //   ]
      // },
      personnelList: {
        list: [
          {
            required: true,
            message: "主要管理人员不能为空",
            trigger: "change"
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.secondStep {
  padding: 0 200px;
  margin-left: 220px;
  display: flex;
  justify-content: center;
  align-content: center;
  .title {
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    position: relative;
    line-height: 20px;
    span {
      margin-right: 16px;
      height: 20px;
      display: inline-block;
      width: 4px;
      background: #ff152e;
    }
    div {
      position: absolute;
      //   top: -2px;
      display: inline-block;
    }
  }
  .el-form-item {
    font-size: 14px !important;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85) !important;
    /deep/.el-form-item__label {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }
    /deep/.el-cascader,
    /deep/.el-cascader .el-input .el-input__inner {
      height: 40px;
      width: 280px;
      .el-input__icon {
        line-height: 40px;
      }
    }
    /deep/.el-cascader .el-input .el-icon-caret-bottom {
      line-height: 40px;
    }
  }
  .el-form-item__content .el-input /deep/input,
  .el-select /deep/.el-input input {
    width: 1006px;
    float: left;
    max-width: 280px;
    height: 40px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #e9ecf7;
  }

  /deep/.el-form-item__content,
  .el-form-item__content /deep/.e-input {
    /*width: 450px;*/
    .el-form-item__error {
      padding: 0;
    }
  }
  /deep/.el-area-selector .selected-adress .selected-show {
    min-width: 250px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px 0 9px;
    font-size: 14px;
    color: #4a4a4a;
    display: block;
    border: 1px solid #e9e9e9;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-form-item__content .el-button {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    border: none;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .el-form-item__content .stopBtn {
    background: rgba(180, 111, 117, 0.08);
    border: 1px solid #ff152e;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff152e;
  }
  .demo-ruleForm .masterDataInformation {
    width: 75%;
  }
  .el-row .el-col {
    display: inline-block;
  }
  .secondStep .el-form-item__content .el-input[data-v-4b198370] /deep/input,
  .secondStep .el-select[data-v-4b198370] .el-input /deep/input {
    height: 130px;
    background: #eee;
  }
  .deviation {
    position: relative;
    left: -100px;
  }
  .addTabIndex /deep/.el-form-item__content {
    width: 1006px;
  }
  .el-form-item__content .nextBtn {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .el-form-item__content .lastBtn {
    background: #fafafa;
    border: 1px solid #dddddd;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
  }
}
.el-table {
  border: 1px solid #fafafa;
  /deep/tbody tr {
    height: 45px !important;
  }
  /deep/thead tr th {
    div {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  /deep/.el-table__body-wrapper .el-table__body tbody tr td div {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>
